import { render, staticRenderFns } from "./CustomerProfileModal.vue?vue&type=template&id=185a2150&scoped=true&"
import script from "./CustomerProfileModal.vue?vue&type=script&lang=js&"
export * from "./CustomerProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProfileModal.vue?vue&type=style&index=0&id=185a2150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a2150",
  null
  
)

export default component.exports